import SvgWrapper from './SvgWrapper';
import { AllergnIconProps } from './types';

const PeanutIcon = ({
  innerColor = '#fefefe',
  outerColor = '#c57b4f',
  ...props
}: AllergnIconProps) => {
  const style = {
    fill: 'none',
    stroke: innerColor,
    strokeWidth: 1.3628,
    strokeMiterlimit: 10,
  };

  return (
    <SvgWrapper {...props}>
      <g
        id="Grupo_116"
        data-name="Grupo 116"
        transform="translate(-348.5 -2094)"
      >
        <g
          id="Rectángulo_23"
          data-name="Rectángulo 23"
          transform="translate(348.5 2094)"
          fill="#fff"
          stroke="#000"
          stroke-width="1"
        >
          <rect width="27" height="27" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="26" height="26" rx="1.5" fill="none" />
        </g>
        <g id="peanut" transform="translate(355.586 2101.086)">
          <g id="Grupo_91" data-name="Grupo 91" transform="translate(0 0)">
            <g id="Grupo_90" data-name="Grupo 90">
              <path
                id="Trazado_9077"
                data-name="Trazado 9077"
                d="M12.759,8.012a3.962,3.962,0,0,0-2.567-2.963l-.046-.016A3.782,3.782,0,0,1,7.781,2.638,3.987,3.987,0,0,0,4.818.073C3.54-.164,1,.216.608.607S-.163,3.536.073,4.815A4.008,4.008,0,0,0,2.686,7.793a3.781,3.781,0,0,1,2.365,2.394,3.94,3.94,0,0,0,2.962,2.565,5.427,5.427,0,0,0,.971.076,7.354,7.354,0,0,0,3.236-.613C12.608,11.831,12.988,9.3,12.759,8.012ZM8.111,12.225A3.464,3.464,0,0,1,5.542,9.967,4.308,4.308,0,0,0,2.821,7.273,3.443,3.443,0,0,1,.6,4.72,9.424,9.424,0,0,1,.908,1.163a8.5,8.5,0,0,0,1.56.316c.373.056.778.117,1.185.192A3.459,3.459,0,0,1,6.222,3.929,4.309,4.309,0,0,0,8.943,6.623a3.418,3.418,0,0,1,2.218,2.552c.076.428.11.74.139,1.016a5.806,5.806,0,0,0,.4,1.711A9.187,9.187,0,0,1,8.111,12.225Zm3.922-.988a5.449,5.449,0,0,1-.2-1.1c-.03-.284-.065-.606-.144-1.053A3.981,3.981,0,0,0,9.075,6.1,3.781,3.781,0,0,1,6.711,3.709,3.985,3.985,0,0,0,3.75,1.145c-.413-.076-.824-.138-1.2-.195C2.237.9,1.891.851,1.6.8A11.007,11.007,0,0,1,3.854.534,4.883,4.883,0,0,1,4.721.6,3.46,3.46,0,0,1,7.29,2.86,4.285,4.285,0,0,0,9.97,5.54l.041.014h0A3.417,3.417,0,0,1,12.23,8.106,9.368,9.368,0,0,1,12.033,11.238Z"
                transform="translate(0 0)"
              />
              <path
                id="Trazado_9078"
                data-name="Trazado 9078"
                d="M278.743,385.079a1.26,1.26,0,0,1-.888-.869.267.267,0,1,0-.524.109,1.774,1.774,0,0,0,1.25,1.27.264.264,0,0,0,.081.013.267.267,0,0,0,.081-.522Z"
                transform="translate(-270.377 -374.376)"
              />
              <path
                id="Trazado_9079"
                data-name="Trazado 9079"
                d="M257.33,278.927a.267.267,0,0,0,.081-.522,1.26,1.26,0,0,1-.888-.869.267.267,0,1,0-.524.109,1.774,1.774,0,0,0,1.25,1.27A.266.266,0,0,0,257.33,278.927Z"
                transform="translate(-249.579 -270.375)"
              />
              <path
                id="Trazado_9080"
                data-name="Trazado 9080"
                d="M129.41,193.076a1.26,1.26,0,0,1-.888-.869.267.267,0,1,0-.524.109,1.774,1.774,0,0,0,1.25,1.27.264.264,0,0,0,.081.013.267.267,0,0,0,.081-.522Z"
                transform="translate(-124.786 -187.184)"
              />
              <path
                id="Trazado_9081"
                data-name="Trazado 9081"
                d="M149.68,106.671a.267.267,0,0,0-.161.509,1.26,1.26,0,0,1,.888.869.268.268,0,0,0,.262.213.278.278,0,0,0,.055-.005.267.267,0,0,0,.207-.316A1.774,1.774,0,0,0,149.68,106.671Z"
                transform="translate(-145.591 -103.986)"
              />
              <path
                id="Trazado_9082"
                data-name="Trazado 9082"
                d="M384.347,362.67a.267.267,0,0,0-.161.509.5.5,0,0,1,.353.334.268.268,0,0,0,.262.213.279.279,0,0,0,.055-.005.267.267,0,0,0,.207-.316A1.02,1.02,0,0,0,384.347,362.67Z"
                transform="translate(-374.377 -353.57)"
              />
              <path
                id="Trazado_9083"
                data-name="Trazado 9083"
                d="M43.543,128.547a.5.5,0,0,1-.353-.334.267.267,0,0,0-.524.109,1.019,1.019,0,0,0,.716.735.263.263,0,0,0,.081.013.267.267,0,0,0,.081-.522Z"
                transform="translate(-41.591 -124.793)"
              />
            </g>
          </g>
        </g>
      </g>
    </SvgWrapper>
  );
};

export default PeanutIcon;
